import * as React from 'react';
import { Prompt } from 'react-router';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Card } from 'material-ui/Card';
import { get } from 'lodash';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import remote from '@inqool/uas-web-core/es/components/controls/remote';

import { Input, InputField, ToggleField, Toggle } from '@components/form';
import { required } from '@utils/validators';
import * as T from '@modules/hr-workDayTypes/_workDayTypesTypes';
import { getWorkDayType } from '@modules/hr-workDayTypes/_workDayTypesActions';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';

const linkBack = '/hr/work-day-types';

const enhance = compose<T.WorkDayTypesFormProps, T.WorkDayTypesFormProps>(
  EntityDetailEnhancer<T.WorkDayTypesEnhancerProps<T.WorkDayType>, T.WorkDayType>({
    getEntity: getWorkDayType,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Typ pracovního dne', to: linkBack },
    { label: get(entity, 'name', 'Nový typ') }
  ]),
  withProps<{}, T.WorkDayTypesForm>(({ entity }) => ({
    initialValues: get(entity, 'id') ? entity : {},
    url: '/metropolis/api/hr/workplan/evidence/types',
    id: get(entity, 'id', '')
  })),
  remote,
  withProps(({ id, items }) => ({
    items: items.filter(o => get(o, 'id') !== id)
  })),
  reduxForm({
    form: 'work-day-types'
  })
);

const View: React.SFC<any> = ({ change, items, closeItem, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={12}>
              <InputField component={Input} type="number" name="order" label="Pořadí *" validate={[required]} />
              <InputField component={Input} name="name" label="Název pozice *" validate={[required]} />
              <ToggleField
                component={Toggle}
                name="active"
                label="Aktivní"
                labelPosition="right"
                onToggle={(_, value) => change('active', value)}
              />
            </Col>
          </Row>
        </Grid>

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const WorkDayTypesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-workDayTypes/WorkDayTypesForm.tsx